var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationPinRgbRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dhl_icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24,6A12.0316,12.0316,0,0,0,12,18a11.679,11.679,0,0,0,.4473,3.1372A12.0629,12.0629,0,0,0,13.18,23.104C13.4488,23.668,24,42,24,42S34.51,23.668,34.7789,23.104a12.0907,12.0907,0,0,0,.7329-1.9668A11.7029,11.7029,0,0,0,36,18,12.0316,12.0316,0,0,0,24,6Zm0,17a5.1418,5.1418,0,0,1-5-5,5.1418,5.1418,0,0,1,5-5,5.1418,5.1418,0,0,1,5,5A5.1418,5.1418,0,0,1,24,23Z",
    fill: "#d70511"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPinRgbRed);
export default __webpack_public_path__ + "static/media/location_pin_rgb_red.1b031c292a0aee572539af2c1a629778.svg";
export { ForwardRef as ReactComponent };